import PayStripeButton from './PayStripeButton';

export default PayStripeButton;
